export const EMAIL_SUBJECT = ['emailSubject'];
export const TIMESTAMP = ['timestamp'];
export const WORKFLOW_ID = ['workflowId'];
export const RECIPIENT_VID = ['recipientVid'];